// @flow

/**
 * @NOTE
 * deviceSizeがサービスで共通化されるまでstay用の値で作成しています。
 * deviceSizeが共通化された時点でこのコードと_media.jsは削除し、
 * packages/shared/styles/media.jsを参照するようにしてください。
 */

export default {}

export const deviceSizes = {
  desktopLg: 1200,
  desktop: 991,
  tablet: 600,
  phone: 480,
}



// WEBPACK FOOTER //
// ./src/components/styles/_variables.js